import {
  border,
  BorderProps,
  color,
  ColorProps,
  compose,
  css,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'

export type NavBarProperty = 'default' | 'inverted'

export interface NavBarProps extends LayoutProps, SpaceProps, ColorProps, BorderProps {
  variant?: NavBarProperty
}

const defaultProps = withDefaultProps<NavBarProps>({
  variant: 'default',
})

export const NavBar = styled.div.attrs<NavBarProps>(defaultProps)(
  ({ theme }) =>
    css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      zIndex: 999,
      height: theme.navigation.height,
      px: [4, 4, 6, 8],
    }),
  variant({
    scale: 'NavBar',
    variants: {
      default: {},
      inverted: {},
    },
  }),
  compose(layout, space, color, border),
)
